import React from 'react';

export const CartesianAxes = ({ viewportWidth = 400, viewportHeight = 300, viewportScale = 1 }) => {
  const scaledWidth = viewportWidth * viewportScale;
  const scaledHeight = viewportHeight * viewportScale;
  const centerX = scaledWidth / 2;
  const centerY = scaledHeight / 2;
  
  return (
    <g>
      <line x1="0" y1={centerY} x2={scaledWidth} y2={centerY} stroke="#666" strokeWidth="1"/>
      <line x1={centerX} y1="0" x2={centerX} y2={scaledHeight} stroke="#666" strokeWidth="1"/>
      <polygon points={`${scaledWidth-5},${centerY} ${scaledWidth-15},${centerY-5} ${scaledWidth-15},${centerY+5}`} fill="#666"/>
      <polygon points={`${centerX},5 ${centerX-5},15 ${centerX+5},15`} fill="#666"/>
      <text x={scaledWidth-15} y={centerY-10} fontSize="12" fill="#666">X</text>
      <text x={centerX+10} y="15" fontSize="12" fill="#666">Y</text>
    </g>
  );
};

export const Cartesian3DAxes = ({ viewportWidth = 400, viewportHeight = 300, viewportScale = 1 }) => {
  const scaledWidth = viewportWidth * viewportScale;
  const scaledHeight = viewportHeight * viewportScale;
  const centerX = scaledWidth / 2;
  const centerY = scaledHeight / 2;
  
  return (
    <g>
      <line x1={centerX} y1={centerY} x2={centerX + 100} y2={centerY} stroke="#666" strokeWidth="1"/>
      <line x1={centerX} y1={centerY} x2={centerX} y2={centerY - 100} stroke="#666" strokeWidth="1"/>
      <line x1={centerX} y1={centerY} x2={centerX - 87} y2={centerY + 50} stroke="#666" strokeWidth="1"/>
      <text x={centerX + 105} y={centerY + 5} fontSize="12" fill="#666">X</text>
      <text x={centerX + 5} y={centerY - 105} fontSize="12" fill="#666">Y</text>
      <text x={centerX - 100} y={centerY + 60} fontSize="12" fill="#666">Z</text>
    </g>
  );
};

